<template>
  <div class="nut-swiper" :class="[direction, { dragging: dragging }]" @touchstart="onTouchStart($event)" @mousedown="onTouchStart($event)">
    <div
      class="nut-swiper-wrap"
      :style="{
        transform: 'translate3d(' + translateX + 'px,' + translateY + 'px,0)',
        'transition-duration': transitionDuration + 'ms',
        '-webkit-transform': 'translate3d(' + translateX + 'px,' + translateY + 'px,0)',
        '-webkit-transition-duration': transitionDuration + 'ms',
        'transition-timing-function': 'ease',
      }"
      @transitionend="onTransitionEnd"
    >
      <slot></slot>
    </div>
    <div class="nut-swiper-pagination" v-show="paginationVisible">
      <span
        class="swiper-pagination-bullet"
        :class="{ active: index + 1 === currentPage }"
        v-for="(slide, index) in slideEls"
        :key="index"
        @click="paginationClickable && setPage(index + 1, true)"
      >
      </span>
    </div>
  </div>
</template>

<script>
/**
 * @see https://github.com/jdf2e/nutui/tree/master/src/packages/swiper
 */
const VERTICAL = 'vertical';
const HORIZONTAL = 'horizontal';
export default {
    name: 'nut-swiper',
    props: {
        direction: {
            type: String,
            default: HORIZONTAL,
            validator: value => [VERTICAL, HORIZONTAL].indexOf(value) > -1,
        },
        paginationVisible: {
            type: Boolean,
            default: false,
        },
        paginationClickable: {
            type: Boolean,
            default: false,
        },
        loop: {
            type: Boolean,
            default: false,
        },
        speed: {
            type: Number,
            default: 500,
        },
        canDragging: {
            type: Boolean,
            default: true,
        },
        autoPlay: {
            type: Number,
            default: 0,
        },
        initPage: {
            type: Number,
            default: 1,
        },
        lazyLoad: {
            type: Boolean,
            default: false,
        },
        lazyLoadUrl: {
            type: String,
            default: '',
        },
        swiperData: {
            type: [Array],
            default() {
                return [];
            },
        },
    },
    watch: {
        swiperData() {
            this.updateEvent();
        },
    },
    data() {
        return {
            dragging: false,
            currentPage: this.initPage,
            lastPage: 1,
            translateX: 0,
            translateY: 0,
            startTranslate: 0,
            slideEls: [],
            translateOffset: 0, // 当前偏移初始位置距离
            transitionDuration: 0, // 切换动画时间
            startPos: null,
            delta: 0, // 拖动距离
            startTime: null,
            isLoop: this.loop,
            timer: null, // 自动播放定时器
            domTimer: null, // 渲染延迟查找
            stopAutoPlay: false, // 停止自动播放
            swiperWrap: null,
            oneSlideTranslate: 0, // 一个slide的大小
        };
    },
    methods: {
    // 下一张
        next() {
            const page = this.currentPage;
            if (page < this.slideEls.length || this.isLoop) {
                this.setPage(page + 1, true, 'NEXT');
            } else {
                this.revert();
            }
        },
        // 上一张
        prev() {
            const page = this.currentPage;
            if (page > 1 || this.isLoop) {
                this.setPage(page - 1, true, 'PREV');
            } else {
                this.revert();
            }
        },
        setPage(page, isHasAnimation, type) {
            if (page === 0) {
                this.currentPage = this.slideEls.length;
            } else if (page === this.slideEls.length + 1) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }
            this.setTranslate(this.getTranslateOfPage(page));
            if (!isHasAnimation) {
                this.slideClassHandle();
            } else {
                this.onTransitionStart(type);
            }
        },
        isHorizontal() {
            return this.direction === HORIZONTAL;
        },
        isVertical() {
            return this.direction === VERTICAL;
        },
        renderLazyDom(slideEls) {
            slideEls.forEach((item) => {
                if (item.className !== 'nut-swiper-slide nut-swiper-slide-selected') {
                    const dom = document.createElement('div');
                    // jd 图片占位图)
                    if (this.lazyLoadUrl) {
                        dom.style.backgroundImage = `url('${this.lazyLoadUrl}')`;
                        dom.className = 'nut-lazy img';
                    } else {
                        dom.className = 'nut-lazy preloader';
                    }
                    item.appendChild(dom);
                }
            });
            return true;
        },
        updateEvent(pageSize) {
            this.$nextTick(() => {
                this.domTimer = setTimeout(() => {
                    if (pageSize !== undefined) this.currentPage = pageSize;
                    this.swiperWrap = this.$el.querySelector('.nut-swiper-wrap');
                    this.slideEls = [...this.swiperWrap.children];
                    if (this.slideEls.length === 0) return;
                    this.getSlideDistance(this.slideEls[0]);
                    if (this.autoPlay !== 0) {
                        this.isLoop = true;
                        this.createAutoPlay();
                    }
                    this.isLoop && this.createLoop();
                    this.setPage(this.currentPage, false);
                    this.lazyLoad && this.renderLazyDom(this.slideEls) && this.imgLazyLoad();
                }, 0);
            });
        },
        slideClassHandle() {
            const selectedSlide = this.$el.querySelector('.nut-swiper-slide-selected');
            selectedSlide && selectedSlide.classList.remove('nut-swiper-slide-selected');
            this.slideEls[this.currentPage - 1].classList.add('nut-swiper-slide-selected');
            this.lastPage = this.currentPage;
        },
        getSlideDistance(el) {
            const styleArr = getComputedStyle(el);
            const marginTop = styleArr.marginTop.replace('px', '') - 0;
            const marginBottom = styleArr.marginBottom.replace('px', '') - 0;
            const marginRight = styleArr.marginRight.replace('px', '') - 0;
            const marginLeft = styleArr.marginLeft.replace('px', '') - 0;
            if (this.isHorizontal()) {
                this.oneSlideTranslate = marginRight + marginLeft + el.offsetWidth;
            } else {
                this.oneSlideTranslate = marginTop + marginBottom + el.offsetHeight;
            }
        },
        onTouchStart(e) {
            this.swiperWrap.addEventListener('touchmove', this.onTouchMove, false);
            this.swiperWrap.addEventListener('touchend', this.onTouchEnd, false);
            this.swiperWrap.addEventListener('mousemove', this.onTouchMove, false);
            this.swiperWrap.addEventListener('mouseup', this.onTouchEnd, false);
            this.startPos = this.getTouchPos(e);
            this.delta = 0;
            this.startTranslate = this.getTranslateOfPage(this.currentPage);
            if (this.isLoop) {
                this.setTranslate(this.startTranslate);
            }
            this.startTime = new Date().getTime();
            this.dragging = true;
            this.transitionDuration = 0;
            this.stopAutoPlay = true;
        },
        onTouchMove(e) {
            if (!this.dragging) return;
            if (this.isHorizontal()) {
                this.delta = this.getTouchPos(e).x - this.startPos.x;
            } else {
                this.delta = this.getTouchPos(e).y - this.startPos.y;
            }
            // let  isQuickAction = (new Date().getTime() - this.startTime) < 200;
            if (this.canDragging && this.computePreventDefault(e)) {
                e.preventDefault();
                this.setTranslate(this.startTranslate + this.delta);
                this.$emit('slideMove', this.getTranslate(), this.$el);
                this.$emit('slide-move', this.getTranslate(), this.$el);
            }
        },
        onTouchEnd() {
            if (!this.dragging) return;
            this.dragging = false;
            this.transitionDuration = this.speed;
            const isQuickAction = new Date().getTime() - this.startTime < 1000;
            if (this.delta < -this.oneSlideTranslate / 2 || (isQuickAction && this.delta < -15)) {
                this.next();
            } else if (this.delta > this.oneSlideTranslate / 2 || (isQuickAction && this.delta > 15)) {
                this.prev();
            } else {
                this.revert();
            }
            this.swiperWrap.removeEventListener('touchmove', this.onTouchMove, false);
            this.swiperWrap.removeEventListener('touchend', this.onTouchEnd, false);
            this.swiperWrap.removeEventListener('mousemove', this.onTouchMove, false);
            this.swiperWrap.removeEventListener('mouseup', this.onTouchEnd, false);
        },
        revert() {
            this.setPage(this.currentPage, true);
        },
        computePreventDefault(e) {
            const pos = this.getTouchPos(e);
            const xDis = Math.abs(this.startPos.x - pos.x);
            const yDis = Math.abs(this.startPos.y - pos.y);
            if (xDis <= 5 && xDis >= 0) {
                return false;
            } if (yDis > 5 && yDis / xDis > 0.5) {
                return false;
            }
            return true;
        },
        getTouchPos(e) {
            const x = e.changedTouches ? e.changedTouches[0].pageX : e.pageX;
            const y = e.changedTouches ? e.changedTouches[0].pageY : e.pageY;
            return { x, y };
        },
        onTransitionStart(type) {
            this.transitionDuration = this.speed;
            this.lazyLoad && this.imgLazyLoad(1);
            if (this.isPageChanged()) {
                this.$emit('slideChangeStart', this.currentPage, this.$el, type);
                this.$emit('slide-change-start', this.currentPage, this.$el, type);
            } else {
                this.$emit('slideRevertStart', this.currentPage, this.$el, type);
                this.$emit('slide-revert-start', this.currentPage, this.$el, type);
            }
        },
        onTransitionEnd() {
            if (this.isPageChanged()) {
                this.$emit('slideChangeEnd', this.currentPage, this.$el);
                this.$emit('slide-change-end', this.currentPage, this.$el);
            } else {
                this.$emit('slideRevertEnd', this.currentPage, this.$el);
                this.$emit('slide-revert-end', this.currentPage, this.$el);
            }
            this.transitionDuration = 0;
            this.delta = 0;
            this.lastPage = this.currentPage;

            this.slideClassHandle();
            if (this.isLoop) {
                this.setTranslate(this.getTranslateOfPage(this.currentPage));
            }
            this.stopAutoPlay = false;
        },
        isPageChanged() {
            return this.lastPage !== this.currentPage;
        },
        setTranslate(value) {
            const translateName = this.isHorizontal() ? 'translateX' : 'translateY';
            this[translateName] = value;
        },
        getTranslate() {
            const translateName = this.isHorizontal() ? 'translateX' : 'translateY';
            return this[translateName];
        },
        getTranslateOfPage(page) {
            if (page === 0) return 0;
            const self = this;
            return (
                -[].reduce.call(
                    this.slideEls,
                    (total, el, i) => (i > page - 2 ? total : total + self.oneSlideTranslate),
                    0,
                ) + this.translateOffset
            );
        },
        createLoop() {
            const swiperWrapEl = this.$el.querySelector('.nut-swiper-wrap');
            const duplicateFirstChild = swiperWrapEl.firstElementChild.cloneNode(true);
            const duplicateLastChild = swiperWrapEl.lastElementChild.cloneNode(true);
            swiperWrapEl.insertBefore(duplicateLastChild, swiperWrapEl.firstElementChild);
            swiperWrapEl.appendChild(duplicateFirstChild);
            this.translateOffset = -this.oneSlideTranslate;
        },
        createAutoPlay() {
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                if (!this.stopAutoPlay) {
                    this.next();
                }
            }, this.autoPlay);
        },
        requestAniFrame() {
            /* eslint-disable */
            return (
                window.requestAnimationFrame || window.webkitRequestAnimationFrame || function (callback) {
                    window.setTimeout(callback, 1000 / 60);
                }
            );
            /* eslint-enabled */
        },
        imgLazyLoad(type) {
            const requestAniFrame = this.requestAniFrame();
            let imgLazyLoadEl;
            requestAniFrame(() => {
                imgLazyLoadEl = this.swiperWrap.querySelectorAll('.nut-img-lazyload');
                if (type === 1) {
                    imgLazyLoadEl = this.slideEls[this.currentPage - 1].querySelectorAll('.nut-img-lazyload');
                }
                imgLazyLoadEl.forEach((item) => {
                    if (!this.checkInView(item) && type !== 1) return;
                    const src = item.getAttribute('data-src');
                    const img = new Image();
                    img.src = src;
                    img.onload = () => {
                        const lazyLoadingEle = item.parentElement.querySelector('.nut-lazy');
                        if (lazyLoadingEle) {
                            item.parentElement.removeChild(lazyLoadingEle);
                        }
                        item.src = src;
                        item.classList.remove('nut-img-lazyload');
                    };
                    img.onerror = () => {
                        item.src = this.lazyLoadUrl;
                        item.classList.remove('nut-img-lazyload');
                    };
                });
            });
        },
        checkInView(imgItem) {
            const imgRect = imgItem.getBoundingClientRect();
            const swiperRect = this.$el.getBoundingClientRect();
            const imgTop = imgRect.top;
            const imgLeft = imgRect.left;
            const swiperWidth = this.$el.clientWidth;
            const swiperHeight = this.$el.clientHeight;
            const swiperTop = swiperRect.top;
            const swiperLeft = swiperRect.left;
            let isInView = true;
            if (imgTop > swiperTop + swiperHeight || imgLeft > swiperLeft + swiperWidth) {
                isInView = false;
            }
            return isInView;
        },
    },
    created() {},
    mounted() {
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.updateEvent();
    },
    destroyed() {
        this.timer = null;
        this.domTimer = null;
    },
    activated() {
        if (this.keepAlive) {
            this.keepAlive = false;
            this.updateEvent();
        }
    },
    deactivated() {
        this.keepAlive = true;
        this.timer = null;
        this.domTimer = null;
    },
};
</script>


<style lang="scss">
.nut-swiper {
  position: relative;
  overflow: hidden;
  height: 200px;
  .nut-swiper-wrap {
    display: flex;
    display: -webkit-flex;
    width: 100%;
    height: 100%;
    transition: all 0ms ease;
    -webkit-transition: all 0ms ease;
  }
  .nut-swiper-slide {
    overflow: hidden;
    flex-shrink: 0;
    -webkit-flex-shrink: 0;
    width: 100%;
    height: 100%;
    cursor: default;
    position: relative;
    @keyframes nut-preloader-spin {
      100% {
        transform: rotate(360deg);
      }
    }
    .nut-lazy {
      &.img {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      &.preloader {
        width: 42px;
        height: 42px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -21px;
        margin-top: -21px;
        z-index: 10;
        transform-origin: 50%;
        animation: nut-preloader-spin 1s infinite linear;
        box-sizing: border-box;
        border: 4px solid #fff;
        border-radius: 50%;
        border-top-color: transparent;
      }
    }
  }
  &.horizontal .nut-swiper-wrap {
    flex-direction: row;
    -webkit-flex-direction: row;
  }
  &.vertical .nut-swiper-wrap {
    flex-direction: column;
    -webkit-flex-direction: column;
  }
  .nut-swiper-pagination {
    position: absolute;
    .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: rgba(255, 255, 255, .8);
      opacity: 0.2;
      transition: all 0.5s ease;
      -webkit-transition: all 0.5s ease;
    }
    .swiper-pagination-bullet.active {
      background-color: rgba(255, 255, 255, .5);
      opacity: 1;
    }
  }

  &.vertical .nut-swiper-pagination {
    right: 10px;
    top: 50%;
    transform: translate3d(0, -50%, 0);
    -webkit-transform: translate3d(0, -50%, 0);
    .swiper-pagination-bullet {
      display: block;
      margin: 6px 0;
    }
  }
  &.horizontal .nut-swiper-pagination {
    bottom: 10px;
    width: 100%;
    text-align: center;
    .swiper-pagination-bullet {
      display: inline-block;
      margin: 0 3px;
    }
  }
  img {
    pointer-events: none;
  }
}
</style>
